<template>
<div class="main">
	<Steps :index="0" :product-name="title" />
	<slot :form="form"></slot>
	<Applicant 
		:info="form.applicantInfo" 
		:upload-file-list="applicantUploadFileList"
		@on-change="setApplicantData" 
		:type="type"
		class="mt20" 
		ref="applicant" />
	<Invoice 
		:info="form.invoiceInfo" 
		ref="invoice" 
		:type="type"
		class="mt20" />
	
	<div class="mt20 center">
        <p>总费用：<span class="price">{{amountValue}}元</span></p>
        <p class="mt10">
			<!-- :disabled="!Boolean(amountValue)" -->
            <Button type="primary" @click="sub" :loading="loading">立即投保</Button>
        </p>
    </div>
	<TrackNotice v-if="id&&isRenew" />
</div>
</template>
<script>
import Steps from './Steps'
import Applicant from './Applicant'
import Invoice from './Invoice'
import { mapState } from 'vuex'
import {applicantUploadFileMap} from '@/pages/haierProduct/common/dictionary'
import TrackNotice from '@/components/common/TrackNotice.vue';
import track from "@/mixin/track";
export default {
	mixins:[track],
    components:{ Steps,Applicant,Invoice,TrackNotice },
    props:{
        bizId:{
            type:String,
            default:''
        },
        productCode:{
            type:String,
            default:''
        },
        amount:{
            type:[String,Number],
            default:''
        },
        title:{
            type:String,
            default:''
        },
		// NEW("新投保保单")，RENEW("续保保单")
		insuranceType:{
            type:String,
            default:'NEW'
        },
    },
	data () {
		return {
			form:{
				bizId:this.bizId,
				productCode:this.productCode,
				applicantInfo:{},
				subjectMatter:[],
				subjectMatterUrls:'',
				invoiceInfo:{
					invoiceType:'NOT'
				}
			},
			amountValue:'',
			loading:false,
			id:this.$route.params.id,
            isRenew:this.$route.query.renew||'',
            companyCode:this.$route.query.code||'',
		}
	},
	computed:{
		...mapState({
			userInfo:state=>state.common.info
		}),
		type(){
			return this.form.applicantInfo.identityType
		},
		applicantUploadFileList(){
			let list=applicantUploadFileMap[this.form.productCode]
			if(list){
				return list.filter(item=>{
					return item.identityType==this.type
				})
			}
			return []
		}
	},
	watch:{
		amount(val){
			this.amountValue=val
		},
		userInfo(){
			this.checkLogin()
		}
	},
	created () {
		if(this.checkLogin()){
			if(this.id){
				this.getInfo()
			}else{
				this.getCompanyInfo();
			}
		}
	},
	mounted(){
		// 重新投保
		if(this.id&&this.isRenew){
			this.track_is_new = true;
			this.$nextTick(()=>{
				this.trackInit();
			})
		} else {
			// 回溯 开始录制
			this.$nextTick(this.startRecord);
		}
		console.log(sessionStorage.track_session_key,'录屏')
	},
	methods:{
		checkLogin(){
			// 检测登录
			if(!this.userInfo.userId){
				if(location.href&&location.href.indexOf('/common.html#/login')==-1){
					window.location = location.origin +'/common.html#/login?bankUrl='+encodeURIComponent(location.href);
				}
				return false
			}else{
				return true
			}
		},
		// 获取服务商信息
		getCompanyInfo(){
			this.$axios.get('/broker/enterprise/findByCode',{
				bizCode:this.companyCode,
				bizId:this.bizId
			}).then(res=>{
				this.form.applicantInfo={
					enterpriseId:res.id,
					identityType:res.identityType,
					subjectName:res.name||'',
					idNumber:res.idNumber||'',
					idCard:res.idNumber||'',
					areaCode:res.areaCode||'',
					address:res.address||'',
					contactName:res.contactName||'',
					contactPhone:res.contactPhone||'',
					contactEmail:res.contactEmail||'',
					annexUrls:res.annexUrls||''
				}
				this.form.invoiceInfo={
					invoiceType:'NOT',
					invoiceName:res.name,
					invoiceUniqueCode:res.idNumber,
					invoiceAddress:res.invoiceAddress||res.address||'',
					invoicePhone:res.invoicePhone||res.contactPhone||'',
					openingBankAccount:res.openingBankAccount||'',
					openingBankName:res.openingBankName||'',
					// invoiceDeliverEmail:res.invoiceDeliverEmail||res.contactEmail||'',
					invoiceDeliverAddress:res.invoiceDeliverAddress||'',
				}
			})
		},
		// 根据id获取信息
		getInfo(){
			this.$axios.post('/broker/insurance/application/detail',{
				applicationId:this.id
			}).then(res=>{
				this.amountValue=res.premium
				this.form=res
				this.form.applicantInfo=res.applicantList&&res.applicantList.length>0?res.applicantList[0]:{}
				this.form.applicantInfo.idNumber=this.form.applicantInfo.idNumber||''
				this.form.applicantInfo.idCard=this.form.applicantInfo.idNumber||''
				
				this.form.invoiceInfo.invoiceName=res.invoiceInfo.invoiceName||res.applicantInfo.subjectName||''
				this.form.invoiceInfo.invoiceUniqueCode=res.invoiceInfo.invoiceUniqueCode||res.applicantInfo.idNumber||''
				this.form.invoiceInfo.email=res.invoiceInfo.invoiceDeliverDestination||''
				this.form.invoiceInfo.postAddress=res.invoiceInfo.invoiceDeliverDestination||''
				this.form.invoiceInfo.invoiceDeliverDestination=res.invoiceInfo.invoiceDeliverDestination||''
			});
		},
		// 校验
		async sub () {
			let slotRecognize=this.$scopedSlots.default()
			let recognize = await slotRecognize[0].context.$refs.recognize.sub();
			let applicant = await this.$refs.applicant.sub();
			let invoice = await this.$refs.invoice.sub();
			if(applicant&&recognize&&invoice){
				this.loading = true;
				this.$axios.post(`/broker/insurance/application/apply.json.all`,{
					...recognize,
					applicantList:[applicant],
					invoiceInfo:invoice,
					bizId:this.bizId,
					productCode:this.productCode,
					insuranceType:this.insuranceType,
				}).then(async res=>{
					this.loading = false;
					if(res.code==10000000){
						// 回溯 停止录制
						await this.stopRecord({
							session_key:sessionStorage.track_session_key,
							policy_id:res.msg||''
						});
						if(!this.id||res.data!=this.id){
							this.$router.replace({
								path:`${this.$route.path}/${res.data}`,
								query:this.$route.query
							})
						}
						this.$emit('sub',res.data)
					} else {
						this.alert(res.msg)
					}
				}).catch(res=>{
					this.loading = false;
				});;
			}
		},
		// 同步投保公司数据，用于更新公司名称和社会代码，开票组件会用到
		setApplicantData(form) {
			this.$set(this.form,'invoiceInfo',{
				invoiceName:form.applicantName,
				invoiceUniqueCode:form.organizationCode,
				invoicePhone:form.contactPhone,
				// invoiceDeliverEmail:form.contactEmail,
				invoiceAddress:form.applicantAddress,
				
			})
		}
	}
}
</script>
<style scoped>
	.main{
		margin-top: 15px;
		padding :30px 40px;
	}
	.mt20{
	    font-size: 25px;
	    line-height: 1.8;
	}
	span.price{
	    color:#FF0000;
	    font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/common/FillInContainer.vue